import styled from 'styled-components';

const MyInfoLink = styled.a`
    text-decoration: none;
    color: red;
    font-size: 0.875rem;

    &:hover {
        color: red;
    }
`;

export default MyInfoLink;